import type { TasksTranslation } from "./en.tasks";

const tasksRu: TasksTranslation = {
  status: {
    pass: "Пройден",
    fail: "Провален",
    blocked: "Заблокирован",
    skipped: "Пропущен",
    untested: "Не проверен",
    stale: "Устарел",
    staleHint: "Кейс изменился после того, как был записан этот результат.",
    summary: "Пройдено: {{pass}}, провалено: {{fail}}, заблокировано: {{blocked}}, пропущено: {{skipped}}, не проверено: {{untested}}",
    nPass: "Пройдено: {{count}}",
    nFail: "Провалено: {{count}}",
    nBlocked: "Заблокировано: {{count}}",
    nSkipped: "Пропущено: {{count}}",
    nStale: "Устарело: {{count}}",
    nUntested: "Не проверено: {{count}}",
  },
  taskState: {
    draft: "Черновик",
    ready_for_test: "Готово к тестированию",
    in_testing: "Тестируется",
    changes_requested: "Нужны исправления",
    ready_for_retest: "Готово к повторной проверке",
    passed: "Пройдено",
    closed: "Закрыто",
  },
  priority: {
    critical: "критичный",
    high: "высокий",
    medium: "средний",
    low: "низкий",
  },
  source: {
    claude: "claude",
    manual: "вручную",
  },
  replyKind: {
    fixed: "Исправлено",
    wont_fix: "Не будет исправлено",
    not_a_bug: "Не баг",
    comment: "Комментарий",
  },
  inbox: {
    title: "Входящие",
    intro: "Задачи, которые ждут вас во всех ваших проектах.",
    toTest: "На проверку",
    toFix: "На исправление",
    toTestEmpty: "Ничего не ждёт тестирования.",
    toFixEmpty: "От вас не ждут исправлений.",
  },
  tasks: {
    filterPeople: "Люди",
    myTurn: "Мой ход",
    mine: "Мои",
    inStateSince: "{{state}} с {{time}}",
    title: "Задачи",
    newTask: "Новая задача",
    search: "Поиск по ключу или названию",
    filterState: "Фильтр по статусу",
    openOnly: "Открытые",
    empty: "Задач пока нет",
    emptyBody: "Создайте задачу здесь или пусть Claude создаст её через CLI.",
    noMatch: "Нет задач, подходящих под фильтры.",
    taskTitle: "Название",
    description: "Описание",
    developer: "Разработчик",
    tester: "Тестировщик",
    unassigned: "Не назначен",
    created: "Задача {{key}} создана",
    keyInvalid: "Используйте ключ задачи: буквы, дефис и число (PAY-482).",
    caseCount: "Кейсов: {{count}}",
    notTested: "Ещё не тестировалась",
    roundN: "Р{{n}}",
    updated: "Обновлено {{time}}",
    task: "Задача",
    state: "Статус",
    progress: "Последний раунд",
    people: "Участники",
  },
  task: {
    turnYours: "Ваш ход",
    turn: {
      developer: "Ждёт разработчика",
      tester: "Ждёт тестировщика",
      manager: "Ждёт, пока менеджер закроет",
    },
    roundN: "Раунд {{n}}",
    markReady: "Готово к тестированию",
    requestRetest: "Запросить повторную проверку",
    startRound: "Начать раунд",
    continueRound: "Продолжить раунд {{n}}",
    viewRound: "Открыть раунд {{n}}",
    finishRound: "Завершить раунд",
    close: "Закрыть задачу",
    reopen: "Открыть снова",
    addCase: "Добавить кейс",
    progressActive: "Раунд {{n}} · записано {{done}} из {{total}}",
    progressLatest: "Раунд {{n}} завершён · записано {{done}} из {{total}}",
    startedBy: "начат {{time}}, {{name}}",
    finishedAt: "завершён {{time}}",
    noCases: "Тест-кейсов пока нет",
    noCasesBody: "Добавьте кейсы здесь или загрузите их из Claude через CLI:",
    liveUpdate: "{{name}} изменил(а) {{what}}",
    liveUpdateGeneric: "{{name}} внёс(ла) изменения в задачу",
    someone: "Кто-то",
    dismiss: "Скрыть",
    tabCases: "Тест-кейсы",
    tabRounds: "Раунды",
    tabActivity: "История",
    tabCode: "Код",
    retestTitle: "Запросить повторную проверку",
    retestHint: "Тестировщик увидит эту заметку, когда начнёт следующий раунд.",
    retestNote: "Что изменилось",
    retestPlaceholder: "Например: исправил TC-3 и TC-4, TC-8 — не баг (см. ответ)",
    retested: "Повторная проверка запрошена",
    markedReady: "Отмечено как готовое к тестированию",
    closedToast: "Задача закрыта",
    reopenedToast: "Задача открыта снова",
    closeTitle: "Закрыть {{key}}?",
    closeBody: "Закрытые задачи скрыты из списков и входящих. Её можно открыть снова; ничего не удаляется.",
    assigneeSaved: "Исполнитель изменён",
    editTask: "Изменить задачу",
    taskSaved: "Задача сохранена",
    noDescription: "Нет описания.",
    actions: "Действия с задачей",
  },
  round: {
    startTitle: "Начать раунд {{n}}",
    scope: "Что тестировать",
    scopeAll: "Все кейсы",
    scopeRetest: "Повторно: проваленные, изменённые и новые",
    selected: "Выбрано {{count}} из {{total}}",
    selectAll: "Выбрать все",
    selectNone: "Снять выбор",
    noneSelected: "Выберите хотя бы один кейс.",
    version: "Версия",
    noVersion: "Без версии",
    taskVersions: "Версии этой задачи",
    otherVersions: "Другие версии",
    build: "Сборка",
    buildPlaceholder: "например, 3.14.0",
    environment: "Окружение",
    envPlaceholder: "например, staging",
    start: "Начать раунд",
    started: "Раунд {{n}} начат",
    finishTitle: "Завершить раунд {{n}}",
    finishUntested: "Не проверено кейсов: {{count}}. Выберите один результат для всех:",
    finishUntestedAs: "Результат для непроверенных кейсов",
    finishNote: "Итог для разработчика",
    finishOutcomeFail: "Есть ошибки: задача вернётся разработчику со статусом «Нужны исправления».",
    finishOutcomePass: "Ошибок нет: задача будет отмечена как пройденная.",
    finish: "Завершить раунд",
    finished: "Раунд {{n}} завершён",
    active: "Идёт",
    done: "Завершён",
    noRounds: "Раундов пока нет. Тестировщик начнёт раунд, когда задача будет готова к тестированию.",
    by: "Кто начал",
    when: "Когда",
    results: "Результаты",
    showMatrix: "Результаты раунда {{n}}",
    hideMatrix: "Скрыть результаты",
    actual: "Фактический результат",
    testedBy: "Кто проверял",
    addedLater: "добавлен во время раунда",
    retestNoteLabel: "Заметка разработчика",
  },
  cases: {
    key: "Ключ",
    case: "Кейс",
    priority: "Приоритет",
    tags: "Теги",
    reply: "Ответ разработчика",
    filterStatus: "Результат в текущем раунде",
    filterAll: "Все",
    filterFailed: "Проваленные",
    filterStale: "Устаревшие",
    filterUntested: "Не проверенные",
    anyPriority: "Любой приоритет",
    anyTag: "Любой тег",
    showArchived: "Показать архивные",
    archived: "В архиве",
    new: "НОВЫЙ",
    editOrder: "Изменить порядок",
    saveOrder: "Сохранить порядок",
    moveUp: "Поднять {{key}}",
    moveDown: "Опустить {{key}}",
    orderSaved: "Порядок сохранён",
    noSection: "Без раздела",
    noMatch: "Нет кейсов, подходящих под фильтры.",
    finding: "находка",
    notInRound: "Не входит в этот раунд",
    roundColumn: "Результат раунда {{n}}",
    open: "Открыть {{key}}",
  },
  caseDetail: {
    preconditions: "Предусловия",
    steps: "Шаги",
    expected: "Ожидаемый результат",
    actual: "Фактически · раунд {{n}}",
    attachments: "Вложения",
    upload: "Прикрепить файлы",
    dropHere: "Перетащите файлы сюда, чтобы прикрепить",
    uploading: "Загрузка…",
    uploaded: "Файл прикреплён",
    tooBig: "Файл должен быть не больше 100 МБ.",
    noAttachments: "Вложений нет.",
    removeAttachment: "Удалить {{name}}",
    attachmentRemoved: "Вложение удалено",
    roundTag: "Р{{n}}",
    history: "История",
    noHistory: "Ещё не проверялся.",
    replies: "Ответы разработчика",
    noReplies: "Ответов пока нет.",
    replyKind: "Ответ",
    replyNote: "Заметка",
    replyPlaceholder: "Например: добавил проверку в API, проверьте снова.",
    sendReply: "Отправить ответ",
    replied: "Ответ отправлен",
    revisions: "Версии",
    revN: "в{{n}}",
    createdRev: "создан",
    changed: "изменено: {{fields}}",
    noChanges: "без изменений в содержании",
    showDiff: "Показать изменения",
    hideDiff: "Скрыть изменения",
    edit: "Изменить",
    archive: "В архив",
    unarchive: "Восстановить",
    archivedToast: "Кейс перенесён в архив",
    unarchivedToast: "Кейс восстановлен",
    by: "{{name}} · {{time}}",
    fields: {
      title: "название",
      preconditions: "предусловия",
      steps: "шаги",
      expected: "ожидаемый результат",
      priority: "приоритет",
      tags: "теги",
      app: "приложение",
    },
    was: "было",
    now: "стало",
    app: "Приложение",
  },
  caseEditor: {
    stepsHint: "Enter добавляет следующий шаг · вставленный список делится на шаги",
    newTitle: "Новый тест-кейс",
    editTitle: "Изменить {{key}}",
    section: "Раздел",
    sectionHint: "Группирует связанные кейсы, например «Возвраты».",
    title: "Что проверяется",
    titlePlaceholder: "например, Возврат больше оплаченной суммы отклоняется",
    preconditions: "Предусловия",
    steps: "Шаги",
    step: "Шаг {{n}}",
    addStep: "Добавить шаг",
    removeStep: "Удалить шаг {{n}}",
    moveStepUp: "Поднять шаг {{n}}",
    moveStepDown: "Опустить шаг {{n}}",
    expected: "Ожидаемый результат",
    priority: "Приоритет",
    tags: "Теги",
    tagsHint: "Через запятую, например negative, refunds",
    app: "Приложение",
    noApp: "Без приложения",
    saved: "Кейс сохранён",
    created: "Кейс {{key}} добавлен",
    liveNotice: "Идёт раунд — тестировщик увидит это изменение с пометкой.",
  },
  runner: {
    back: "Назад к задаче",
    progress: "Записано {{done}} из {{total}} · провалено: {{fail}}",
    shortcuts: "J / K — переход · P — пройден · F — провален · B — заблокирован · S — пропустить · N — заметка",
    skip: "Пропустить",
    note: "Заметка",
    noteRequired: "Опишите, что произошло на самом деле — обязательно для «провален» и «заблокирован».",
    notePlaceholder: "Что произошло на самом деле?",
    paste: "Вставьте скриншот (⌘V / Ctrl+V) или перетащите файлы",
    prev: "Назад",
    next: "Далее",
    staleBanner: "Кейс изменился после проверки — проверьте его снова.",
    archivedBanner: "Этот кейс перенесён в архив во время раунда.",
    addedLater: "Добавлен во время раунда",
    previous: "Раунд {{n}}",
    devReply: "Разработчик · {{kind}}",
    readOnly: "Вы просматриваете раунд. Записывать результаты могут только тестировщики и менеджеры.",
    roundFinished: "Раунд завершён. Результаты доступны только для чтения.",
    addFinding: "Добавить находку",
    findingTitle: "Новая находка",
    findingHint: "Проблема вне описанных кейсов. Добавляется в этот раунд как проваленная.",
    findingTitleLabel: "Что не так",
    findingExpected: "Ожидалось",
    findingActual: "Фактически",
    findingAdded: "Находка {{key}} добавлена",
    empty: "В этом раунде нет кейсов.",
    attachedTo: "Прикреплено к {{key}}",
    cases: "Кейсы раунда",
    stepDone: "Шаг {{n}} выполнен",
    clear: "Сбросить результат",
    allDone: "У всех кейсов есть результат. Завершите раунд, когда будете готовы.",
  },
  activity: {
    empty: "Пока ничего не происходило.",
    kinds: {
      task_created: "создал(а) задачу",
      gitlab_link_added: "добавил(а) связь с GitLab",
      gitlab_link_confirmed: "подтвердил(а) связь с GitLab",
      gitlab_link_removed: "убрал(а) связь с GitLab",
      task_updated: "изменил(а) задачу",
      task_transition: "сменил(а) статус задачи",
      cases_synced: "синхронизировал(а) тест-кейсы",
      case_created: "добавил(а) кейс",
      case_updated: "изменил(а) кейс",
      case_archived: "перенёс(ла) кейс в архив",
      case_unarchived: "восстановил(а) кейс",
      cases_reordered: "изменил(а) порядок кейсов",
      round_started: "начал(а) раунд",
      round_finished: "завершил(а) раунд",
      round_cases_added: "добавил(а) кейсы в раунд",
      result_recorded: "записал(а) результат",
      result_cleared: "сбросил(а) результат",
      finding_added: "добавил(а) находку",
      reply_added: "ответил(а) на ошибку",
      attachment_added: "прикрепил(а) файл",
      attachment_deleted: "удалил(а) файл",
      task_title_changed: "переименовал(а) задачу",
      task_description_changed: "изменил(а) описание",
      task_status_changed: "изменил(а) статус",
      task_due_changed: "изменил(а) срок",
      task_priority_changed: "изменил(а) приоритет",
      task_assignee_added: "назначил(а) исполнителя",
      task_assignee_removed: "снял(а) исполнителя",
      task_tester_changed: "сменил(а) тестировщика",
      task_parent_changed: "сменил(а) родительскую задачу",
      task_epic_changed: "сменил(а) эпик",
      task_release_changed: "сменил(а) релиз",
      task_tag_added: "добавил(а) метку",
      task_tag_removed: "убрал(а) метку",
      task_attachment_added: "прикрепил(а) файл к задаче",
      task_attachment_removed: "удалил(а) файл задачи",
      task_moved_out: "перенёс(ла) задачу в другой проект",
      task_moved_in: "перенёс(ла) задачу сюда",
      task_deleted: "удалил(а) задачу",
      task_mark_ready: "отметил(а) готовой к тестированию",
      task_request_retest: "запросил(а) повторную проверку",
    },
    system: "Mixla",
    counts: {
      created: "добавлено: {{count}}",
      updated: "изменено: {{count}}",
      archived: "в архиве: {{count}}",
    },
  },
  tokens: {
    apiDocs: "Документация API →",
    tryIt: "Проверьте:",
    howToUse: "Как пользоваться токеном →",
    revokeBotBody: "Всё, что использует этот токен, сразу перестанет работать.",
    title: "Доступ для CLI",
    intro: "Личные токены позволяют CLI mixla — и Claude через него — действовать от вашего имени. Храните их как пароли.",
    name: "Название",
    namePlaceholder: "например, MacBook · Claude Code",
    expiry: "Срок действия",
    days: "{{count}} дн.",
    create: "Создать токен",
    createdTitle: "Ваш новый токен",
    createdWarning: "Скопируйте его сейчас. Больше он показан не будет.",
    command: "Войдите в CLI командой:",
    lastUsed: "Последнее использование",
    created: "Создан",
    expires: "Истекает",
    revoke: "Отозвать",
    revokeTitle: "Отозвать «{{name}}»?",
    revokeBody: "CLI с этим токеном сразу перестанет работать.",
    revoked: "Токен отозван",
    empty: "Токенов пока нет.",
    done: "Готово",
  },
  cliGuide: {
    title: "Настройка CLI + Claude Code",
    time: "около 5 минут, один раз на компьютер",
    os: "Ваша система",
    install: {
      title: "Установите CLI mixla",
      body: "Работает на macOS и Linux. Устанавливается в ~/.local/bin и подскажет, если этой папки нет в PATH. Повторный запуск обновляет CLI.",
      bodyWindows: "Вставьте в PowerShell. Устанавливает mixla.exe для вашего пользователя (без прав администратора) и добавляет в PATH. Повторный запуск обновляет CLI.",
    },
    token: {
      title: "Создайте личный токен",
      body: "Используйте форму ниже. Назовите его по компьютеру, например «MacBook · Claude Code». Токен показывается один раз — вместе с готовой командой входа.",
      action: "К форме токена",
    },
    login: {
      title: "Войдите в CLI",
      body: "Вставьте команду входа из окна токена (в ней уже этот сервер и ваш токен). Затем проверьте, кто вы.",
    },
    skill: {
      title: "Научите Claude работать с Mixla",
      body: "Claude Code узнаёт процесс Mixla (загрузка кейсов, исправление сбоев, баги) из короткого файла-инструкции — навыка (skill). Выберите, куда его установить:",
      scope: "Куда установить навык",
      global: "Во все мои репозитории",
      globalTag: "рекомендуется",
      globalHint: "Сохраняется в домашней папке (~/.claude/skills/mixla). Работает в любом репозитории на этом компьютере; коммитить ничего не нужно.",
      repo: "Только в один репозиторий",
      repoHint: "Сохраняется внутри репозитория (.claude/skills/mixla). Закоммитьте его — и коллеги с Claude Code получат его тоже.",
      repoCd: "cd путь/к/репозиторию",
      copy: "Скопировать навык",
      copyHint: "Без CLI? Скопируйте навык и сохраните его как",
    },
    link: {
      title: "Привяжите репозиторий к проекту Mixla (необязательно)",
      body: "Команды задач и так знают проект по ключу задачи (PAY-482 → PAY). Для команд багов один раз запишите проект в репозиторий, чтобы ни вам, ни Claude не указывать --project:",
      project: "Проект",
    },
    use: {
      todo: "Что ждёт меня в Mixla?",
      title: "Попросите Claude",
      body: "Откройте Claude Code в этом репозитории и попросите обычными словами, например:",
      push: "Загрузи тест-кейсы для PAY-482",
      fix: "Исправь ошибки, которые тестировщики нашли в PAY-482",
      bug: "Посмотри BUG-12 и найди первопричину",
    },
    trouble: "Не работает? «mixla whoami» покажет, выполнен ли вход. Для отозванного или истёкшего токена создайте новый и войдите снова. Настройки хранятся в ~/.config/mixla/config.json.",
  },
};

export default tasksRu;
